module.exports = __webpack_public_path__ + "img/ISO14001_UKAS.d9aa2170.png";